import Types from '../../types';

export const initialState = { error: null, loading: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.SIGN_IN_CREDENTIALS_ERROR: {
      return {
        ...state,
        error: { type: Types.SIGN_IN_CREDENTIALS_ERROR },
        loading: false,
      };
    }

    case Types.SIGN_IN_EMAIL_CHANGE: {
      return {
        ...state,
        error: null,
      };
    }

    case Types.SIGN_IN_USER_DISABLED_ERROR: {
      return {
        ...state,
        error: { type: Types.SIGN_IN_USER_DISABLED_ERROR },
        loading: false,
      };
    }

    case Types.SIGN_IN_COGNITO_ERROR: {
      return {
        ...state,
        error: { type: Types.SIGN_IN_COGNITO_ERROR },
        loading: false,
      };
    }
    case Types.SIGN_IN_SUBMIT: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case Types.SHOW_MODAL: {
      return {
        ...state,
        showModal: true,
      };
    }
    case Types.SIGN_IN_SESSION_AUTH_ERROR: {
      return {
        ...state,
        error: { type: Types.SIGN_IN_SESSION_AUTH_ERROR },
        loading: false,
      };
    }
    case Types.REGISTER_SESSION_AUTH_ERROR_DURING_SIGN_IN: {
      return {
        ...state,
        error: { type: Types.REGISTER_SESSION_AUTH_ERROR_DURING_SIGN_IN },
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};
